import * as z from "zod/v4";

export const deleteSenderEmail = {
  name: "deleteSenderEmail" as const,
  input: z.object({ email: z.string().email() }),
  output: z.object({ success: z.boolean() }),
};
